export const BUSINESS_TIMEZONE = "Asia/Amman";
export const UTC_OFFSET_MINUTES = 180; // UTC+3
export const HAJEZ_SUPPORT_WHATSAPP = "962785054509"; // Official Support Channel
export const HAJEZ_SUPPORT_EMAIL = "contact@krude.app";
export const HAJEZ_SUPPORT_PHONE = "+962 785054509";

export const LOYALTY_REWARD_THRESHOLD = 50;
